import { defineMessages } from 'react-intl';

export const paymentsMessages = defineMessages({
    payments: {
        id: 'payments',
        defaultMessage: 'Payments',
    },
    payment: {
        id: 'payment',
        defaultMessage: 'Payment',
    },
    type: {
        id: 'type',
        defaultMessage: 'Type',
    },
    moneyAccount: {
        id: 'money-account',
        defaultMessage: 'Money account',
    },
    paid: {
        id: 'paid',
        defaultMessage: 'Paid',
    },
    cancelled: {
        id: 'cancelled',
        defaultMessage: 'Cancelled',
    },
    failed: {
        id: 'failed',
        defaultMessage: 'Failed',
    },
    refunded: {
        id: 'refunded',
        defaultMessage: 'Refunded',
    },
    rollback: {
        id: 'rollback',
        defaultMessage: 'Rollback',
    },
    amount: {
        id: 'amount',
        defaultMessage: 'Amount',
    },
    financials: {
        id: 'financials',
        defaultMessage: 'Financials',
    },
    deletePayment: {
        id: 'delete-payment',
        defaultMessage: 'Delete payment',
    },
    deletePaymentSuccess: {
        id: 'delete-payment-success',
        defaultMessage: 'Payment deleted',
    },
    deletePaymentSuccessDescription: {
        id: 'delete-payment-success-description',
        defaultMessage: 'The payment has been successfully deleted.',
    },
    confirmDeletePayment: {
        id: 'confirm-delete-payment',
        defaultMessage: 'Are you sure you want to delete this payment? This action cannot be undone.',
    },
    deletePaymentSubtitle: {
        id: 'delete-payment-subtitle',
        defaultMessage: 'Permanently delete payment',
    },
    reference: {
        id: 'reference',
        defaultMessage: 'Reference',
    },
    createPaymentSuccess: {
        id: 'create-payment-success',
        defaultMessage: 'Payment created',
    },
    createPaymentSuccessDescription: {
        id: 'create-payment-success-description',
        defaultMessage: 'The payment has been successfully created.',
    },
    addPaymentSubtitle: {
        id: 'add-payment-subtitle',
        defaultMessage: 'Create a new payment',
    },
    editPaymentSubtitle: {
        id: 'edit-payment-subtitle',
        defaultMessage: 'Edit payment',
    },
    updatePaymentSuccess: {
        id: 'update-payment-success',
        defaultMessage: 'Payment updated',
    },
    updatePaymentSuccessDescription: {
        id: 'update-payment-success-description',
        defaultMessage: 'The payment has been successfully updated.',
    },
    paymentDashboard: {
        id: 'payment-dashboard',
        defaultMessage: 'Payment dashboard',
    },
    backToAllPayments: {
        id: 'back-to-all-payments',
        defaultMessage: 'Back to all payments',
    },
    allocatedAmount: {
        id: 'allocated-amount',
        defaultMessage: 'Allocated amount',
    },
    remainingAmount: {
        id: 'remaining-amount',
        defaultMessage: 'Remaining amount',
    },
    price: {
        id: 'price',
        defaultMessage: 'Price',
    },
    amountWithTax: {
        id: 'amount-with-tax',
        defaultMessage: 'Amount with tax',
    },
    paymentStatusPartial: {
        id: 'payment-status-partial',
        defaultMessage: 'Partial',
    },
    paymentStatus: {
        id: 'payment-status',
        defaultMessage: 'Payment status',
    },
    paymentStatusNone: {
        id: 'payment-status-none',
        defaultMessage: 'Not paid',
    },
    taxAmount: {
        id: 'tax-amount',
        defaultMessage: 'Tax',
    },
});
